<div class="footer" id="livebetfooterpage">
  <div class="dateContainer" [ngStyle]="{visibility: isShowDayChangeArea ? 'visible' : 'hidden' }" >
    <div class="livebet_footer_div " style="padding:5px;" id="livebetfooterdatebutton">

      <ul class="livebetfooter_buttons_ul">
        <li *ngFor="let day of this.livebet_dayArray;let i=index;let first = first;" class="livebetfooter_buttons_li">

          <ng-container *ngIf="first">
            <button
              class="tiny ui button {{this.livebet_footer_menu_active == i  ? 'active': ''}} livebetfooterdatebutton_button terminalButton"
              (click)="Livebet_footerdateSelected(i,day)">
              <span style="font-size:15px;">{{'Today' | t }}</span><br/>
              <span></span>
            </button>
          </ng-container>
          <ng-container *ngIf="!first">
            <button
              class="tiny ui button {{this.livebet_footer_menu_active == i  ? 'active': ''}} livebetfooterdatebutton_button terminalButton"
              (click)="Livebet_footerdateSelected(i,day)"><span style="font-size:15px;">{{this.livebet_dayname[i] | t }}</span><br/>
              <span>{{day}}</span></button>
          </ng-container>


        </li>
      </ul>

    </div>
  </div>
  <br/>

  <div id="livebetfooter_bottom" class="ui grid" style="margin-bottom:0px">
    <div class="five wide column">
      <button class="tiny ui button livebetdatedown_button terminalButton" id="livebetfooter_result"
              (click)="Results_Modal_Open_From_Live()" *ngIf="this.activeDomain == 'wett' "><span style="font-size:15px;" >{{"Results" | t}}</span>
      </button>

      <button class="tiny ui button livebetdatedown_button terminalButton" id="ticket-keyboard"
              (click)="TicketKeyboardModalOpen()" style="padding: 0">
        <span style="font-size:15px;">
          <i class="large barcode icon"></i>
          {{"TicketChecker" | t}}

        </span>
      </button>

      <button class="tiny ui icon button  terminalButton" style="height:52px;width:50px;margin-left:1px;"
              (click)="Keyboard_Search_Open_Modal()"><i style="font-size: 1em !important;" class="search icon"></i></button>
    </div>
    <div class="five wide column" id="livebetfooter_updown">

      <div class="tiny ui buttons">
        <button class="ui icon button livebetdatedown_button terminalButton" (click)="upScrollLiveBetFooter()">
          <i class="huge caret up icon" style="position:relative;bottom:8px"></i></button>
        <button class="ui icon button livebetdatedown_button terminalButton" (click)="downScrollLiveBetFooter()">
          <i class="huge caret down icon" style="position:relative;bottom:8px"></i></button>

      </div>
    </div>
    <div class="six wide column" id="livebetfooter_explanationdiv">
      <span style="font-size:14px;font-weight:700;padding:5px">{{"Sort" | t}}</span>
      <button class="tiny ui left attached button switchType" style="color:black;min-height: 50px;"
              (click)="this.tournamentsService.setActiveSortTypeOfLive('time')"
                [ngClass]="this.tournamentsService.activeSortTypeOfLive === 'time' ? 'Allscreen_Menu_Active_Item' : ''">

        <span style="font-size:20px">{{"Time" | t}}</span>
      </button>

      <button class="tiny ui right attached button switchType" style="color:black;min-height: 50px;"
              (click)="this.tournamentsService.setActiveSortTypeOfLive('standart')"
               [ngClass]="this.tournamentsService.activeSortTypeOfLive === 'standart' ? 'Allscreen_Menu_Active_Item' : ''" >
        <span style="font-size:20px">{{"Standard" | t}}</span>
      </button>

      <button class="tiny ui button livebetdatedown_button terminalButton" id="livebetfooter_explanationbutton"
              (click)="OpenExplanationModalLive()">
        <span style="font-size:15px;">{{"Explanation" | t}}</span>
      </button>
    </div>

  </div>

</div>

<comp_livebets_keyboard_search_modal></comp_livebets_keyboard_search_modal>
<comp_explanation_modal></comp_explanation_modal>

<style>

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
</style>
